import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useInstitutions from '@/hooks/data/useInstitutions';
import InstitutionsContext from '@/contexts/data/InstitutionsContext';
import { QueryInstitutionsResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';
import TrialContext from '@/contexts/data/TrialContext';


export interface IInstitutionsProviderProps {
    initial?: QueryInstitutionsResponse;
}

export const InstitutionsProvider: FC<PropsWithChildren<IInstitutionsProviderProps>> = ({ initial, children }) => {
    const { data: trial } = useContext(TrialContext);
    const institutions = useInstitutions(trial ? {trialId: trial.id} : undefined, { revalidateOnFocus: false, fallbackData: initial});

    return (

        <InstitutionsContext.Provider value={institutions}>
            <IsLoading name="institutions" loading={institutions.loading} validating={institutions.validating}/>
            {children}
        </InstitutionsContext.Provider>
    );
}

export default InstitutionsProvider;
